module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.getSectionRange), function(size, index) {
    return [_c('div', {
      class: 'col-lg-' + (12 / _vm.sectionSize) + ' col-md-' + (12 / _vm.sectionSize)
    }, _vm._l((_vm.getAttributesForSection(index)), function(attribute) {
      return _c('ul', [_c('li', [_c('span', [_vm._v(_vm._s(attribute['name']) + ": ")]), _vm._v(" "), _vm._l((attribute['values']), function(value, vIndex) {
        return _c('span', [_c('i', [_c('b', [(vIndex > 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('span', {
          class: _vm.getCssClassForSelectedAttr(attribute['id'], value['id'], value['value'])
        }, [_vm._v(_vm._s(value['value']))])])])])
      })], 2)])
    }), 0)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-526f2952!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAttribute/attributes.vue
// module id = 1288
// module chunks = 2